export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  formValues: {
    apetite: null,
    ratherEat: null,
    smoking: null,
  },
})
